// GENERATED FILE - do not hand-edit.
// Source of truth: scripts/source-data/*.js. Run `yarn build-cards` after
// changing source data and commit both together.

export const STARTER_CARDS = [
  {
    "id": "starter-1",
    "name": "U.E.S. McCandless II 3195-D",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 1,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-2",
    "name": "U.E.S. McNair 1232-H",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-3",
    "name": "U.E.S. Stewart 7936-F",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-4",
    "name": "U.E.S. Solovyov 2463-H",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-5",
    "name": "U.E.S. Atkov 1044-E",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-6",
    "name": "U.E.S. Sharma 7947-G",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "starter-7",
    "name": "U.E.S. Scobee 9566-B",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "starter-8",
    "name": "U.E.S. Nelson 7775-B",
    "shipClass": "Knight Class Cargo Vessel",
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "starter-9",
    "name": "U.E.S. Van Hoften 5906-B",
    "shipClass": "Scott Class Mining Vessel",
    "sector": 9,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "starter-10",
    "name": "U.E.S. Hart 2790-D",
    "shipClass": "Scott Class Mining Vessel",
    "sector": 10,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "starter-11",
    "name": "U.E.S. Volk 9084-B",
    "shipClass": "Scott Class Mining Vessel",
    "sector": 11,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "starter-12",
    "name": "U.E.S. Spring 3973-E",
    "shipClass": "Scott Class Mining Vessel",
    "sector": 12,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    }
  }
];

export const COLONY_CARDS = [
  {
    "id": "colony-frisch",
    "name": "U.E.C. Frisch Outpost",
    "shipClass": "Serling Star Settlement",
    "sector": 1,
    "cost": 9,
    "vp": 3
  },
  {
    "id": "colony-tinbergen",
    "name": "U.E.C. Tinbergen Outpost",
    "shipClass": "Serling Star Settlement",
    "sector": 2,
    "cost": 12,
    "vp": 4
  },
  {
    "id": "colony-samuelson",
    "name": "U.E.C. Samuelson Outpost",
    "shipClass": "Serling Star Settlement",
    "sector": 3,
    "cost": 15,
    "vp": 5
  },
  {
    "id": "colony-kuznets",
    "name": "U.E.C. Kuznets Outpost",
    "shipClass": "Serling Star Settlement",
    "sector": 4,
    "cost": 18,
    "vp": 6
  },
  {
    "id": "colony-hicks-base",
    "name": "U.E.C. Hicks Base",
    "shipClass": "Cameron Class Star Settlement",
    "sector": 5,
    "cost": 21,
    "vp": 7
  },
  {
    "id": "colony-arrow-base",
    "name": "U.E.C. Arrow Base",
    "shipClass": "Cameron Class Star Settlement",
    "sector": 6,
    "cost": 24,
    "vp": 8
  },
  {
    "id": "colony-leontief-base",
    "name": "U.E.C. Leontief Base",
    "shipClass": "Cameron Class Star Settlement",
    "sector": 7,
    "cost": 27,
    "vp": 9
  },
  {
    "id": "colony-myrdal-base",
    "name": "U.E.C. Myrdal Base",
    "shipClass": "Cameron Class Star Settlement",
    "sector": 8,
    "cost": 30,
    "vp": 10
  },
  {
    "id": "colony-hayek",
    "name": "U.E.C. Hayek Colony",
    "shipClass": "Kubrick Class Star Settlement",
    "sector": 9,
    "cost": 33,
    "vp": 11
  },
  {
    "id": "colony-kantorovich",
    "name": "U.E.C. Kantorovich Colony",
    "shipClass": "Kubrick Class Star Settlement",
    "sector": 10,
    "cost": 36,
    "vp": 12
  },
  {
    "id": "colony-koopmans",
    "name": "U.E.C. Koopmans Colony",
    "shipClass": "Kubrick Class Star Settlement",
    "sector": 11,
    "cost": 39,
    "vp": 13
  },
  {
    "id": "colony-friedman",
    "name": "U.E.C. Friedman Colony",
    "shipClass": "Kubrick Class Star Settlement",
    "sector": 12,
    "cost": 42,
    "vp": 14
  }
];

export const EXPANSION_COLONIES = [
  {
    "id": "genesis-colony-peterschmidt",
    "name": "U.E.C. Peterschmidt",
    "shipClass": "Estate Class Star Settlement",
    "sector": 12,
    "cost": 150,
    "vp": null,
    "instantWin": true
  },
  {
    "id": "genesis-colony-trudeau",
    "name": "U.E.C. Trudeau",
    "shipClass": "Frontier Class Star Settlement",
    "sector": 1,
    "cost": 9,
    "vp": 3,
    "secondaryReward": {
      "kind": "income",
      "amount": 2
    },
    "allOthersReward": {
      "kind": "income",
      "amount": 1
    }
  },
  {
    "id": "genesis-colony-paquette",
    "name": "U.E.C. Paquette",
    "shipClass": "33-D Alien Colony",
    "sector": 1,
    "cost": 9,
    "vp": 3,
    "endOfTurnRewardAllPlayers": {
      "kind": "credits",
      "amount": 5
    }
  },
  {
    "id": "genesis-colony-zinser",
    "name": "U.E.C. Zinser",
    "shipClass": "Victory Class Orbital Colony",
    "sector": 11,
    "cost": 39,
    "vp": 12,
    "excessCreditsToVp": true
  },
  {
    "id": "genesis-colony-carman",
    "name": "U.E.C. Carman",
    "shipClass": "Moonwalker Class Orbital Colony",
    "sector": 7,
    "cost": 26,
    "vp": 8,
    "orChoice": {
      "kind": "flatResource",
      "reward": {
        "kind": "credits",
        "amount": 60
      }
    }
  },
  {
    "id": "genesis-colony-rowland",
    "name": "U.E.C. Rowland",
    "shipClass": "Moonwalker Class Orbital Colony",
    "sector": 8,
    "cost": 28,
    "vp": 9,
    "orChoice": {
      "kind": "flatResource",
      "reward": {
        "kind": "income",
        "amount": 8
      }
    }
  },
  {
    "id": "genesis-colony-tzioti",
    "name": "U.E.C. Tzioti",
    "shipClass": "29-E Alien Colony",
    "sector": 5,
    "cost": 21,
    "vp": 5,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "station",
      "min": 1,
      "max": 6
    }
  },
  {
    "id": "genesis-colony-wood",
    "name": "U.E.C. Wood",
    "shipClass": "72-R Alien Colony",
    "sector": 6,
    "cost": 24,
    "vp": 6,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "deployed",
      "min": 1,
      "max": 6
    }
  },
  {
    "id": "genesis-colony-buckendorf",
    "name": "U.E.C. Buckendorf",
    "shipClass": "10-U Alien Colony",
    "sector": 7,
    "cost": 26,
    "vp": 7,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "station",
      "min": 7,
      "max": 9
    }
  },
  {
    "id": "genesis-colony-manolis",
    "name": "U.E.C. Manolis",
    "shipClass": "59-L Alien Colony",
    "sector": 8,
    "cost": 28,
    "vp": 8,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "station",
      "min": 10,
      "max": 12
    }
  },
  {
    "id": "genesis-colony-eaton",
    "name": "U.E.C. Eaton",
    "shipClass": "65-H Alien Colony",
    "sector": 9,
    "cost": 33,
    "vp": 9,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "deployed",
      "min": 7,
      "max": 9
    }
  },
  {
    "id": "genesis-colony-mccool",
    "name": "U.E.C. McCool",
    "shipClass": "91-X Alien Colony",
    "sector": 10,
    "cost": 36,
    "vp": 10,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "deployed",
      "min": 10,
      "max": 12
    }
  },
  {
    "id": "genesis-colony-livingston",
    "name": "U.E.C. Livingston",
    "shipClass": "07-J Alien Colony",
    "sector": 11,
    "cost": 39,
    "vp": 11,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zoneChoice": true,
      "min": 1,
      "max": 12
    }
  },
  {
    "id": "genesis-colony-zimmerman",
    "name": "U.E.C. Zimmerman",
    "shipClass": "46-V Alien Colony",
    "sector": 12,
    "cost": 42,
    "vp": 12,
    "orChoice": {
      "kind": "sectorRangeReward",
      "zone": "both",
      "min": 1,
      "max": 12
    }
  },
  {
    "id": "genesis-colony-hobart",
    "name": "U.E.C. Hobart",
    "shipClass": "Frontier Class Star Settlement",
    "sector": 2,
    "cost": 12,
    "vp": 4,
    "sharedDiceReroll": true
  },
  {
    "id": "genesis-colony-lashgari",
    "name": "U.E.C. Lashgari",
    "shipClass": "Outpost Class Star Settlement",
    "sector": 4,
    "cost": 18,
    "vp": 5,
    "sharedDiceReroll": true
  },
  {
    "id": "genesis-colony-laderoute",
    "name": "U.E.C. Laderoute",
    "shipClass": "Frontier Class Star Settlement",
    "sector": 3,
    "cost": 15,
    "vp": 5,
    "allPlayersChargeAnywhere": true
  },
  {
    "id": "genesis-colony-wootton",
    "name": "U.E.C. Wootton",
    "shipClass": "04-F Alien Colony",
    "sector": 2,
    "cost": 12,
    "vp": 4,
    "allPlayersChargeAllEligible": true
  },
  {
    "id": "genesis-colony-holcomb",
    "name": "U.E.C. Holcomb",
    "shipClass": "Outpost Class Star Settlement",
    "sector": 5,
    "cost": 21,
    "vp": 6,
    "deployToOtherPlayer": true
  },
  {
    "id": "genesis-colony-chu",
    "name": "U.E.C. Chu",
    "shipClass": "Outpost Class Star Settlement",
    "sector": 6,
    "cost": 24,
    "vp": 4,
    "pairSwapChoice": {
      "options": [
        [
          7,
          6
        ],
        [
          8,
          5
        ]
      ]
    }
  },
  {
    "id": "genesis-colony-burton",
    "name": "U.E.C. Burton",
    "shipClass": "Monument Class Star Settlement",
    "sector": 7,
    "cost": 26,
    "vp": 5,
    "pairSwapChoice": {
      "options": [
        [
          9,
          4
        ],
        [
          10,
          3
        ]
      ]
    }
  },
  {
    "id": "genesis-colony-bolme",
    "name": "U.E.C. Bolme",
    "shipClass": "Monument Class Star Settlement",
    "sector": 8,
    "cost": 28,
    "vp": 6,
    "pairSwapChoice": {
      "options": [
        [
          11,
          2
        ],
        [
          12,
          1
        ]
      ]
    }
  },
  {
    "id": "genesis-colony-clair",
    "name": "U.E.C. Clair",
    "shipClass": "Polestar Class Orbital Colony",
    "sector": 5,
    "cost": 21,
    "vp": 7,
    "allPlayersChargeLeftNeighbor": true
  },
  {
    "id": "genesis-colony-fitzgerald",
    "name": "U.E.C. Fitzgerald",
    "shipClass": "Polestar Class Orbital Colony",
    "sector": 4,
    "cost": 18,
    "vp": 6,
    "allPlayersDrawAndGift": {
      "level": 2
    }
  },
  {
    "id": "genesis-colony-lepore",
    "name": "U.E.C. Lepore",
    "shipClass": "46-G Alien Colony",
    "sector": 3,
    "cost": 15,
    "vp": 5,
    "allPlayersDrawAndClaim": {
      "level": 1
    }
  },
  {
    "id": "genesis-colony-reese",
    "name": "U.E.C. Reese",
    "shipClass": "Journey Class Orbital Colony",
    "sector": 1,
    "cost": 9,
    "vp": 1,
    "tempResourceModifier": {
      "resourceKind": "credits",
      "mode": "double"
    }
  },
  {
    "id": "genesis-colony-nunn",
    "name": "U.E.C. Nunn",
    "shipClass": "Journey Class Orbital Colony",
    "sector": 2,
    "cost": 12,
    "vp": 2,
    "tempResourceModifier": {
      "resourceKind": "income",
      "mode": "double"
    }
  },
  {
    "id": "genesis-colony-yaple",
    "name": "U.E.C. Yaple",
    "shipClass": "Journey Class Orbital Colony",
    "sector": 3,
    "cost": 15,
    "vp": 3,
    "tempResourceModifier": {
      "resourceKind": "vp",
      "mode": "double",
      "excludeColonySource": true
    }
  },
  {
    "id": "genesis-colony-veger",
    "name": "U.E.C. Veger",
    "shipClass": "Victory Class Orbital Colony",
    "sector": 12,
    "cost": 42,
    "vp": null,
    "tempResourceModifier": {
      "resourceKind": "credits",
      "mode": "convert",
      "convertTo": "vp"
    }
  },
  {
    "id": "genesis-colony-vlad",
    "name": "U.E.C. Vlad",
    "shipClass": "Polestar Class Orbital Colony",
    "sector": 6,
    "cost": 24,
    "vp": 6,
    "forcedDieChoice": true
  },
  {
    "id": "genesis-colony-dancey",
    "name": "U.E.C. Dancey",
    "shipClass": "Moonwalker Class Orbital Colony",
    "sector": 9,
    "cost": 33,
    "vp": 10,
    "orChoice": {
      "kind": "rollUntilSeven"
    }
  },
  {
    "id": "genesis-colony-akey",
    "name": "U.E.C. Akey",
    "shipClass": "Monument Class Star Settlement",
    "sector": 9,
    "cost": 0,
    "vp": 11,
    "claimCondition": {
      "kind": "deployedInEverySector"
    }
  },
  {
    "id": "genesis-colony-harbison",
    "name": "U.E.C. Harbison",
    "shipClass": "Estate Class Star Settlement",
    "sector": 10,
    "cost": 0,
    "vp": 12,
    "claimCondition": {
      "kind": "totalCharges",
      "amount": 9
    }
  },
  {
    "id": "genesis-colony-mara",
    "name": "U.E.C. Mara",
    "shipClass": "Estate Class Star Settlement",
    "sector": 11,
    "cost": 0,
    "vp": 13,
    "claimCondition": {
      "kind": "income",
      "amount": 14
    }
  },
  {
    "id": "genesis-colony-bongiu",
    "name": "U.E.C. Bongiu",
    "shipClass": "Victory Class Orbital Colony",
    "sector": 10,
    "cost": 0,
    "vp": 12,
    "claimCondition": {
      "kind": "sectorDeployedCount",
      "amount": 7
    }
  },
  {
    "id": "genesis-colony-satkowiak",
    "name": "U.E.C. Satkowiak",
    "shipClass": "88-W Alien Colony",
    "sector": 4,
    "cost": 18,
    "vp": 6,
    "tradeCards": true
  },
  {
    "id": "biodome-colony-seedwell",
    "name": "U.E.C. Seedwell Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 1,
    "cost": 9,
    "vp": 2,
    "onBuyReward": {
      "kind": "text",
      "effect": {
        "kind": "emptySectorChoice"
      }
    },
    "onBuyRewardOptional": true
  },
  {
    "id": "biodome-colony-planton",
    "name": "U.E.C. Planton Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 2,
    "cost": 12,
    "vp": 4,
    "discardShipThenClaim": {
      "level": 1
    }
  },
  {
    "id": "biodome-colony-circarth",
    "name": "U.E.C. Circarth Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 3,
    "cost": 15,
    "vp": 5,
    "colonyAnySector": true
  },
  {
    "id": "biodome-colony-settleraph",
    "name": "U.E.C. Settleraph Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 4,
    "cost": 18,
    "vp": 5,
    "ongoingModifier": "buyOneSectorHigher"
  },
  {
    "id": "biodome-colony-hiveco",
    "name": "U.E.C. Hiveco Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 5,
    "cost": 21,
    "vp": 6,
    "buyerChargeAnywhere": 1
  },
  {
    "id": "biodome-colony-thrivax",
    "name": "U.E.C. Thrivax Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 6,
    "cost": 24,
    "vp": 6,
    "ongoingModifier": "sumPlusOneDie"
  },
  {
    "id": "biodome-colony-binoffa",
    "name": "U.E.C. Binoffa Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 7,
    "cost": 27,
    "vp": 9,
    "allPlayersChargeAnywhere": true
  },
  {
    "id": "biodome-colony-chao",
    "name": "U.E.C. Chao Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 8,
    "cost": 30,
    "vp": 10,
    "sharedReward": {
      "kind": "income",
      "amount": 3
    }
  },
  {
    "id": "biodome-colony-exanik",
    "name": "U.E.C. Exanik Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 9,
    "cost": 33,
    "vp": 11,
    "extraTurn": true
  },
  {
    "id": "biodome-colony-grippen",
    "name": "U.E.C. Grippen Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 10,
    "cost": 36,
    "vp": 12,
    "endgameRitualRolls": 3
  },
  {
    "id": "biodome-colony-fryekova",
    "name": "U.E.C. Frye-Kova Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 11,
    "cost": 39,
    "vp": 13,
    "allPlayersDeployCount": 4
  },
  {
    "id": "biodome-colony-terasys",
    "name": "U.E.C. Terasys Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 12,
    "cost": 50,
    "vp": null,
    "setVpRelativeToMax": -1
  },
  {
    "id": "biodome-colony-grovego",
    "name": "U.E.C. Grovego Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 1,
    "cost": 9,
    "vp": 3,
    "delayGameEndOneRound": true
  },
  {
    "id": "biodome-colony-ion",
    "name": "U.E.C. Ion Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 2,
    "cost": 12,
    "vp": 3,
    "ongoingModifier": "buyOtherPlayersColonyReward"
  },
  {
    "id": "biodome-colony-coasite",
    "name": "U.E.C. Coasite Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 3,
    "cost": 15,
    "vp": 5,
    "allPlayersClaimTop": {
      "level": 2
    }
  },
  {
    "id": "biodome-colony-kifoky",
    "name": "U.E.C. Kifoky Outpost",
    "shipClass": "Nadir Class Biodome Settlement",
    "sector": 4,
    "cost": 18,
    "vp": 6,
    "allPlayersChargeAnywhere": true
  },
  {
    "id": "biodome-colony-huxiu",
    "name": "U.E.C. Hu-Xiu Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 5,
    "cost": 21,
    "vp": 7,
    "ongoingModifier": "mirrorDice"
  },
  {
    "id": "biodome-colony-hivvu",
    "name": "U.E.C. Hivvu Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 6,
    "cost": 24,
    "vp": 8,
    "moveDeployedToSector": {
      "fromSectors": [
        1,
        2,
        3,
        4,
        5
      ],
      "to": 6
    }
  },
  {
    "id": "biodome-colony-nikovsky",
    "name": "U.E.C. Nikovsky Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 7,
    "cost": 27,
    "vp": 9,
    "reverseTurnOrder": true
  },
  {
    "id": "biodome-colony-vosiki",
    "name": "U.E.C. Vosiki Colony",
    "shipClass": "Ascension Class Biodome Settlement",
    "sector": 8,
    "cost": 30,
    "vp": 8,
    "ongoingModifier": "buyShipsDeployed"
  },
  {
    "id": "biodome-colony-cytek",
    "name": "U.E.C. Cytek Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 9,
    "cost": 33,
    "vp": 9,
    "moveDeployedToSector": {
      "fromSectors": "all",
      "to": 9
    }
  },
  {
    "id": "biodome-colony-cycolonic",
    "name": "U.E.C. Cycolonic Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 10,
    "cost": 36,
    "vp": 10,
    "ongoingModifier": "claimBeforeRoll"
  },
  {
    "id": "biodome-colony-rinova",
    "name": "U.E.C. Rinova Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 11,
    "cost": 39,
    "vp": 13,
    "extraTurn": true
  },
  {
    "id": "biodome-colony-kostovicha",
    "name": "U.E.C. Ko-Stovicha Base",
    "shipClass": "Zenith Class Biodome Settlement",
    "sector": 12,
    "cost": 80,
    "vp": null,
    "setVpAbsolute": 39
  }
];

export const SHIPYARD_LEVEL_1 = [
  {
    "id": "l1-ivanchenkov",
    "name": "U.E.S. Ivanchenkov 2754-H",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 4,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-musgrave",
    "name": "U.E.S. Musgrave 5650-E",
    "shipClass": "Bradbury Class Carrier",
    "level": 1,
    "cost": 4,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l1-bluford",
    "name": "U.E.S. Bluford 5120-E",
    "shipClass": "Modified Bradbury Class Carrier",
    "level": 1,
    "cost": 4,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-aleksandrov",
    "name": "U.E.S. Aleksandrov 5155-G",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-lichtenberg",
    "name": "U.E.S. Lichtenberg 9384-H",
    "shipClass": "Wells Class Star Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-ryumin",
    "name": "U.E.S. Ryumin 4713-C",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-tuan",
    "name": "U.E.S. Tuân 8623-B",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-crippen",
    "name": "U.E.S. Crippen 7733-C",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-brergovoy",
    "name": "U.E.S. Brergovoy 9890-C",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "l1-shaw",
    "name": "U.E.S. Shaw 1873-C",
    "shipClass": "Wells Class Star Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-malyshev",
    "name": "U.E.S. Malyshev 9767-E",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-remek",
    "name": "U.E.S. Remek 8252-H",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 4,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-romanenko",
    "name": "U.E.S. Romanenko 8599-H",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-thornton",
    "name": "U.E.S. Thornton 8524-G",
    "shipClass": "Wells Class Star Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-gurragchaa",
    "name": "U.E.S. Gürragchaa 3972-D",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-merbold",
    "name": "U.E.S. Merbold 6865-D",
    "shipClass": "Gunn Class Cargo Cruiser",
    "level": 1,
    "cost": 4,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-fullerton",
    "name": "U.E.S. Fullerton 2005-A",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-truly",
    "name": "U.E.S. Truly 9239-H",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-gardner",
    "name": "U.E.S. Gardner 7506-E",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l1-bobko",
    "name": "U.E.S. Bobko 6010-E",
    "shipClass": "Bradbury Class Carrier",
    "level": 1,
    "cost": 4,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l1-farkas",
    "name": "U.E.S. Farkas 3405-F",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "l1-changdiaz",
    "name": "U.E.S. Chang-Diaz 3555-H",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-parker",
    "name": "U.E.S. Parker 8635-F",
    "shipClass": "Wells Class Star Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "text": "Choose the sector to your left or right.",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "l1-lenoir",
    "name": "U.E.S. Lenoir 7021-B",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-kizim",
    "name": "U.E.S. Kizim 1379-H",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-jahn",
    "name": "U.E.S. Jähn 8920-C",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 5
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l1-strekalov",
    "name": "U.E.S. Strekalov 7422-E",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-savinykh",
    "name": "U.E.S. Savinykh 8526-G",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-hartsfield",
    "name": "U.E.S. Hartsfield 5562-G",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l1-hauck",
    "name": "U.E.S. Hauck 5084-D",
    "shipClass": "Bradbury Class Carrier",
    "level": 1,
    "cost": 3,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l1-peterson",
    "name": "U.E.S. Peterson 5325-H",
    "shipClass": "Bradbury Class Carrier",
    "level": 1,
    "cost": 3,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l1-ivanov",
    "name": "U.E.S. Ivanov 8387-E",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-popov",
    "name": "U.E.S. Popov 3919-A",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l1-allen",
    "name": "U.E.S. Allen 4004-C",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 3,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-lyakhov",
    "name": "U.E.S. Lyakhov 4181-D",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-savitskaya",
    "name": "U.E.S. Savitskaya 6659-G",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 8
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    }
  },
  {
    "id": "l1-chretien",
    "name": "U.E.S. Chrétien 3182-C",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "l1-brandenstein",
    "name": "U.E.S. Brandenstein 3161-C",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l1-fabian",
    "name": "U.E.S. Fabian 4787-B",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l1-overmyer",
    "name": "U.E.S. Overmyer 3792-A",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 9
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 7
      }
    }
  },
  {
    "id": "l1-prunariu",
    "name": "U.E.S. Prunariu 7750-G",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-dzhanibekov",
    "name": "U.E.S. Dzhanibekov 1999-G",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 3,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-serebrov",
    "name": "U.E.S. Serebrov 1243-G",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    }
  },
  {
    "id": "l1-engle",
    "name": "U.E.S. Engle 1913-A",
    "shipClass": "Paul Class Cargo Vessel",
    "level": 1,
    "cost": 2,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-thagard",
    "name": "U.E.S. Thagard 4684-B",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l1-ride",
    "name": "U.E.S. Ride 3066-E",
    "shipClass": "Williamson Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l1-tamayomendez",
    "name": "U.E.S. Tamayo-Mendez 4759-G",
    "shipClass": "Tolkien Class Cargo Carrier",
    "level": 1,
    "cost": 2,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l1-hermaszewski",
    "name": "U.E.S. Hermaszewski 5586-E",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 3,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 6
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "biodome-gaerry",
    "name": "U.E.C. Gaerry 2350-D",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-raydn",
    "name": "U.E.C. Raydn 1694-C",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-freysa",
    "name": "U.E.C. Freysa 1072-B",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-nandez",
    "name": "U.E.C. Nandez 0137-A",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-kivrin",
    "name": "U.E.S. Kivrin 4972-B",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 5,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-campbell",
    "name": "U.E.S. Campbell 4745-C",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-winston",
    "name": "U.E.S. Winston 4700-A",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-niven",
    "name": "U.E.S. Niven 4530-B",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-mccaffery",
    "name": "U.E.S. McCaffery 4451-B",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-leguin",
    "name": "U.E.S. LeGuin 4175-C",
    "shipClass": "Odyssey Class Expedition Cruiser",
    "level": 1,
    "cost": 5,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-cixin",
    "name": "U.E.S. Cixin 0741-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-pollard",
    "name": "U.E.S. Pollard 0639-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-drake",
    "name": "U.E.S. Drake 0576-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-robinson",
    "name": "U.E.S. Robinson 0464-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-lengle",
    "name": "U.E.S. L'Engle 0358-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-magellan",
    "name": "U.E.S. Magellan 0283-A",
    "shipClass": "Sentry Class Survey Craft",
    "level": 1,
    "cost": 5,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-griffin",
    "name": "U.E.S. Griffin 2500-A",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-defiant",
    "name": "U.E.S. Defiant 2491-C",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-mastiff",
    "name": "U.E.S. Mastiff 2467-B",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-quilan",
    "name": "U.E.S. Quilan 2184-C",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-kingston",
    "name": "U.E.S. Kingston 2077-D",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-kane",
    "name": "U.E.S. Kane 2002-F",
    "shipClass": "Gallant Class Command Ship",
    "level": 1,
    "cost": 4,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "genesis-jammer",
    "name": "U.E.S. Jammer 8725-A",
    "shipClass": "Runabout Class Recon Command Cruiser",
    "level": 1,
    "cost": 2,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 3,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 2,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    }
  },
  {
    "id": "genesis-vetrov",
    "name": "U.E.S. Vetrov 8602-B",
    "shipClass": "Runabout Class Recon Command Cruiser",
    "level": 1,
    "cost": 4,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 2,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 2,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    }
  },
  {
    "id": "genesis-raka",
    "name": "U.E.S. Raka 5144-D",
    "shipClass": "Wayfarer Class Freight Runner",
    "level": 1,
    "cost": 5,
    "sector": 1,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 8
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-polaris",
    "name": "U.E.S. Polaris 5015-E",
    "shipClass": "Wayfarer Class Freight Runner",
    "level": 1,
    "cost": 5,
    "sector": 3,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 8
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-astro",
    "name": "U.E.S. Astro 5217-C",
    "shipClass": "Wayfarer Class Freight Runner",
    "level": 1,
    "cost": 5,
    "sector": 5,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 8
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-harrington",
    "name": "U.E.S. Harrington 7843-B",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 1,
    "cost": 5,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-romano",
    "name": "U.E.S. Romano 8250-D",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 1,
    "cost": 5,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "genesis-gallagher",
    "name": "U.E.S. Gallagher 8896-C",
    "shipClass": "Morgan Class Courier Craft",
    "level": 1,
    "cost": 5,
    "sector": 12,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-bear",
    "name": "U.E.S. Bear 7627-C",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 1,
    "cost": 5,
    "sector": 11,
    "station": {},
    "endOfTurnReward": {
      "kind": "income",
      "amount": 1
    },
    "endOfTurnSecondaryReward": {
      "kind": "vp",
      "amount": 1
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-atwood",
    "name": "U.E.S. Atwood 8852-D",
    "shipClass": "Morgan Class Courier Craft",
    "level": 1,
    "cost": 5,
    "sector": 10,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    }
  },
  {
    "id": "genesis-lockley",
    "name": "U.E.S. Lockley 7439-E",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 1,
    "cost": 5,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-bancroft",
    "name": "U.E.S. Bancroft 8648-E",
    "shipClass": "Morgan Class Courier Craft",
    "level": 1,
    "cost": 5,
    "sector": 8,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-stelline",
    "name": "U.E.S. Stelline 7042-B",
    "shipClass": "Maultier Class Cargo Transport",
    "level": 1,
    "cost": 5,
    "sector": 6,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-columbo",
    "name": "U.E.S. Columbo 7030-A",
    "shipClass": "Maultier Class Cargo Transport",
    "level": 1,
    "cost": 5,
    "sector": 4,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-rico",
    "name": "U.E.S. Rico 7018-B",
    "shipClass": "Maultier Class Cargo Transport",
    "level": 1,
    "cost": 5,
    "sector": 2,
    "station": {},
    "endOfTurnReward": {
      "kind": "credits",
      "amount": 4
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-weyland",
    "name": "U.E.S. Weyland 7393-D",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 1,
    "cost": 3,
    "sector": 7,
    "station": {},
    "endOfTurnReward": {
      "kind": "income",
      "amount": 1
    },
    "endOfTurnSecondaryReward": {
      "kind": "vp",
      "amount": 1
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-joi",
    "name": "JOI",
    "shipClass": "Leisure Class Resort Ship",
    "level": 1,
    "cost": 2,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "colony",
          "reward": {
            "kind": "credits",
            "amount": 2
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "colony",
          "reward": {
            "kind": "credits",
            "amount": 2
          }
        }
      }
    }
  },
  {
    "id": "genesis-zephyr",
    "name": "Zephyr",
    "shipClass": "Leisure Class Resort Ship",
    "level": 1,
    "cost": 4,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 2,
          "reward": {
            "kind": "credits",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 2,
          "reward": {
            "kind": "credits",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-rogue-star",
    "name": "Rogue Star",
    "shipClass": "Rover Class Treasure Excavator",
    "level": 1,
    "cost": 2,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    }
  },
  {
    "id": "genesis-iron-dragon",
    "name": "Iron Dragon",
    "shipClass": "Buccaneer Class Treasure Excavator",
    "level": 1,
    "cost": 2,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    }
  },
  {
    "id": "genesis-black-diamond",
    "name": "Black Diamond",
    "shipClass": "Galley Class Treasure Excavator",
    "level": 1,
    "cost": 2,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "keepUnspentCredits"
        }
      }
    }
  },
  {
    "id": "genesis-helios",
    "name": "U.E.S. Helios 8998-A",
    "shipClass": "Halo Class Solar Sail",
    "level": 1,
    "cost": 4,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "placeChargeUpToN",
          "max": 3
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "placeChargeUpToN",
          "max": 3
        }
      }
    }
  },
  {
    "id": "genesis-radiant",
    "name": "U.E.S. Radiant 8974-B",
    "shipClass": "Halo Class Solar Sail",
    "level": 1,
    "cost": 2,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "placeChargeUpToN",
          "max": 3
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "placeChargeUpToN",
          "max": 3
        }
      }
    }
  },
  {
    "id": "genesis-valiant",
    "name": "U.E.S. Valiant 9899-H",
    "shipClass": "Hercules Class Tractor Tug",
    "level": 1,
    "cost": 5,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "exchangeWithAdjacentSector"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "exchangeWithAdjacentSector"
        }
      }
    }
  },
  {
    "id": "genesis-plutus",
    "name": "Plutus",
    "shipClass": "Gilded Class Luxury Yacht",
    "level": 1,
    "cost": 2,
    "sector": 11,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 24
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 18
          }
        }
      }
    }
  },
  {
    "id": "genesis-lazarus",
    "name": "U.E.S. Lazarus 3054-A",
    "shipClass": "Brokkr Class Repair Ship",
    "level": 1,
    "cost": 3,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 8
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 6
          }
        }
      }
    }
  },
  {
    "id": "genesis-everdeen",
    "name": "U.E.S. Everdeen 9906-E",
    "shipClass": "Intrepid Class Munitions Carrier",
    "level": 1,
    "cost": 3,
    "sector": 12,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 8
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 6
          }
        }
      }
    }
  },
  {
    "id": "genesis-brin",
    "name": "U.E.S. Brin 1820-C",
    "shipClass": "Quarry Class Asteroid Mine",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-gavin",
    "name": "U.E.S. Gavin 1846-B",
    "shipClass": "Quarry Class Asteroid Mine",
    "level": 1,
    "cost": 3,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-walsh",
    "name": "U.E.S. Walsh 1896-C",
    "shipClass": "Quarry Class Asteroid Mine",
    "level": 1,
    "cost": 4,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-pegasus",
    "name": "U.E.S. Pegasus 0022-A",
    "shipClass": "Prototype Explorer Class Experimental Drive",
    "level": 1,
    "cost": 5,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "bonusRoll"
        }
      },
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "modifyDiceTotal",
          "min": 1,
          "max": 3
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "bonusRoll"
        }
      },
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "modifyDiceTotal",
          "min": 1,
          "max": 1
        }
      }
    }
  },
  {
    "id": "terraproxima-baltar",
    "name": "U.E.S. Baltar 7119-A",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-worlorn",
    "name": "U.E.S. Worlorn 7423-B",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-zartas",
    "name": "U.E.S. Zartas 8740-A",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-armitage",
    "name": "U.E.S. Armitage 6276-B",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-nezu",
    "name": "U.E.S. Nezu 5051-A",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-clavius",
    "name": "U.E.S. Clavius 6946-C",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 4,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-ursus",
    "name": "U.E.S. Ursus 8023-E",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-asogi",
    "name": "U.E.S. Asōgi 9464-F",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-kyoko",
    "name": "U.E.S. Kyoko 9591-B",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-rotwang",
    "name": "U.E.S. Rotwang 2603-E",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-cornelius",
    "name": "U.E.S. Cornelius 3280-C",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-zaius",
    "name": "U.E.S. Zaius 0098-A",
    "shipClass": "Stargazer Class Relay Station",
    "level": 1,
    "cost": 3,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "same",
          "shift": 0,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "triggerZoneReward",
          "zone": "station"
        }
      }
    }
  },
  {
    "id": "terraproxima-gavryn",
    "name": "U.E.S. Gavryn 1292-B",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 8,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "terraproxima-enders",
    "name": "U.E.S. Enders 0146-A",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "terraproxima-larris",
    "name": "U.E.S. Larris 4838-C",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 12,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 6
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 4
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "terraproxima-darinell",
    "name": "U.E.S. Darinell 3620-B",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 11,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 5
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 3
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "terraproxima-camdon",
    "name": "U.E.S. Camdon 2505-A",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 10,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 4
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "terraproxima-shaene",
    "name": "U.E.S. Shaene 1733-C",
    "shipClass": "Valkyrie Class Fast Response Command Ship",
    "level": 1,
    "cost": 3,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 3
        },
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "timing": "green",
        "effect": {
          "kind": "modifyDieFace"
        }
      }
    }
  },
  {
    "id": "shypluto-parise",
    "name": "U.E.S. Parise 8659-E",
    "shipClass": "Le Guin Class Light Command Cruiser",
    "level": 1,
    "cost": 2,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 3,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 2,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    }
  },
  {
    "id": "shypluto-ochoa",
    "name": "U.E.S. Ochoa 2483-D",
    "shipClass": "Wells Class Star Cruiser",
    "level": 1,
    "cost": 4,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "left",
          "shift": 1,
          "chainExtra": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "right",
          "shift": 1,
          "chainExtra": true
        }
      }
    }
  },
  {
    "id": "shypluto-ivins",
    "name": "U.E.S. Ivins 7024-A",
    "shipClass": "Le Guin Class Light Command Cruiser",
    "level": 1,
    "cost": 2,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 4,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 3,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    }
  },
  {
    "id": "shypluto-tognini",
    "name": "U.E.S. Tognini 3038-A",
    "shipClass": "Dickson Class Cargo Runner",
    "level": 1,
    "cost": 2,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "hardWay": {
          "value": 4,
          "reward": {
            "kind": "credits",
            "amount": 8
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "hardWay": {
          "value": 4,
          "reward": {
            "kind": "credits",
            "amount": 7
          }
        }
      }
    }
  },
  {
    "id": "shypluto-artsebarsky",
    "name": "U.E.S. Artsebarsky 8275-D",
    "shipClass": "Herbert Class Mining Vessel",
    "level": 1,
    "cost": 4,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "shypluto-reiter",
    "name": "U.E.O. Reiter 4913-H",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 3,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-ghidzenko",
    "name": "U.E.O. Ghidzenko 1223-B",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 3,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-gernhardt",
    "name": "U.E.O. Gernhardt 8885-C",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 3,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-rominger",
    "name": "U.E.O. Rominger 5061-H",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 3,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-coleman",
    "name": "U.E.O. Coleman 3534-G",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 4,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-lopez-alegria",
    "name": "U.E.O. Lopez-Alegria 7549-H",
    "shipClass": "Trumbull Class Research Station",
    "level": 1,
    "cost": 4,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-oswald",
    "name": "U.E.S. Oswald 4732-E",
    "shipClass": "Vance Class Fuel Runner",
    "level": 1,
    "cost": 3,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          3
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    }
  },
  {
    "id": "shypluto-leslie",
    "name": "U.E.S. Leslie 8989-H",
    "shipClass": "Zelazny Class Tractor Tug",
    "level": 1,
    "cost": 2,
    "sector": 8,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "exchangeWithAdjacentSector"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "exchangeWithAdjacentSector"
        }
      }
    }
  }
];

export const SHIPYARD_LEVEL_2 = [
  {
    "id": "l2-rozhdestvensky",
    "name": "U.E.S. Rozhdestvensky 6723-C",
    "shipClass": "Silverberg Class Command Tug",
    "level": 2,
    "cost": 7,
    "sector": 10,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          2
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 4
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 2,
          "sectorB": 11
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 4
        },
        "timing": "red",
        "effect": {
          "kind": "setDice",
          "dice": "one"
        }
      }
    }
  },
  {
    "id": "l2-sarafanov",
    "name": "P.S.S. Sarafanov 6334-C",
    "shipClass": "Norton Class Cargo Tug",
    "level": 2,
    "cost": 8,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 4
        },
        "timing": "blue",
        "effect": {
          "kind": "buyCard"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 3
        },
        "timing": "red",
        "effect": {
          "kind": "buyCard"
        }
      }
    }
  },
  {
    "id": "l2-kerwin",
    "name": "U.E.S. Kerwin 8426-A",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 10
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 7
      }
    }
  },
  {
    "id": "l2-lousma",
    "name": "U.E.S. Lousma 6040-C",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 9
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    }
  },
  {
    "id": "l2-sevastyanov",
    "name": "U.E.S. Sevastyanov 6862-D",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-filipchenko",
    "name": "U.E.S. Filipchenko 9745-C",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 9
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l2-kubasov",
    "name": "U.E.S. Kubasov 3192-G",
    "shipClass": "Merritt Class Cargo Tug",
    "level": 2,
    "cost": 9,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null,
          2,
          3
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 5,
          "sectorB": 8
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-rukavishnikov",
    "name": "U.E.S. Rukavishnikov 3402-C",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-worden",
    "name": "U.E.S. Worden 8663-H",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-duke",
    "name": "U.E.S. Duke 6222-C",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-klimuk",
    "name": "U.E.S. Klimuk 6800-G",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 9,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 6
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "l2-swigert",
    "name": "U.E.S. Swigert 2715-C",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 5
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-mitchell",
    "name": "U.E.S. Mitchell 6176-D",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-glazkov",
    "name": "U.E.S. Glazkov 3371-B",
    "shipClass": "Asimov Class Exploration Carrier",
    "level": 2,
    "cost": 7,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 10
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l2-garriott",
    "name": "U.E.S. Garriott 6531-E",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 8
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    }
  },
  {
    "id": "l2-pogue",
    "name": "U.E.S. Pogue 5353-G",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-artyukhin",
    "name": "U.E.S. Artyukhin 7727-D",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 9,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "l2-gorbatko",
    "name": "U.E.S. Gorbatko 2007-F",
    "shipClass": "Clarke Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-bean",
    "name": "U.E.S. Bean 1925-D",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 6
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-brand",
    "name": "U.E.S. Brand 5208-D",
    "shipClass": "Asimov Class Exploration Carrier",
    "level": 2,
    "cost": 8,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-patsayev",
    "name": "U.E.S. Patsayev 6859-H",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-volkov",
    "name": "U.E.S. Volkov 9103-G",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 8
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 3
      }
    }
  },
  {
    "id": "l2-lebedev",
    "name": "U.E.S. Lebedev 5128-B",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l2-carr",
    "name": "U.E.S. Carr 7510-H",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 9,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-weitz",
    "name": "U.E.S. Weitz 3134-C",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 11
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 8
      }
    }
  },
  {
    "id": "l2-grechko",
    "name": "U.E.S. Grechko 1421-A",
    "shipClass": "Asimov Class Exploration Carrier",
    "level": 2,
    "cost": 8,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-yeliseyev",
    "name": "U.E.S. Yeliseyev 6380-D",
    "shipClass": "Merritt Class Cargo Tug",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          3
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 6,
          "sectorB": 7
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-kovalyonok",
    "name": "P.P.S. Kovalyonok 8127-H",
    "shipClass": "Modified Merritt Class Cargo Tug",
    "level": 2,
    "cost": 7,
    "sector": 12,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 1,
              "count": 3
            }
          ]
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 2,
              "count": 1
            }
          ]
        }
      }
    }
  },
  {
    "id": "l2-zudov",
    "name": "U.E.S. Zudov 2056-G",
    "shipClass": "Verne Class Hypernet Gate",
    "level": 2,
    "cost": 7,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "exchangeCard"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "exchangeCard"
        }
      }
    }
  },
  {
    "id": "l2-gibson",
    "name": "U.E.S. Gibson 4003-B",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 9,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l2-slayton",
    "name": "U.E.S. Slayton 5363-B",
    "shipClass": "Asimov Class Exploration Carrier",
    "level": 2,
    "cost": 8,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-mattingly",
    "name": "U.E.S. Mattingly 4618-C",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-evans",
    "name": "U.E.S. Evans 7316-E",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 8,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-dobrovolsky",
    "name": "U.E.S. Dobrovolsky 5643-E",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-schweickart",
    "name": "U.E.S. Schweickart 5209-E",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 8,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-irwin",
    "name": "U.E.S. Irwin 8339-H",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-khrunov",
    "name": "U.E.S. Khrunov 6194-G",
    "shipClass": "Heinlein Class Command Cruiser",
    "level": 2,
    "cost": 9,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l2-roosa",
    "name": "U.E.S. Roosa 1689-A",
    "shipClass": "Giger Class Carrier",
    "level": 2,
    "cost": 8,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l2-schmitt",
    "name": "U.E.S. Schmitt 9828-E",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 8,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l2-makarov",
    "name": "U.E.S. Makarov 6674-G",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    }
  },
  {
    "id": "l2-lazarev",
    "name": "U.E.S. Lazarev 4784-B",
    "shipClass": "Fate Class Cargo Vessel",
    "level": 2,
    "cost": 7,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 5
      }
    }
  },
  {
    "id": "l2-zholobov",
    "name": "P.S.S. Zholobov 1830-F",
    "shipClass": "Modified Merritt Class Cargo Tug",
    "level": 2,
    "cost": 7,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          3
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 4,
          "sectorB": 9
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": {
          "kind": "vp",
          "amount": 2
        },
        "timing": "blue",
        "effect": {
          "kind": "buyCard"
        }
      }
    }
  },
  {
    "id": "l2-gubarev",
    "name": "U.E.S. Gubarev 1743-B",
    "shipClass": "Heinlein Class Command Cruiser",
    "level": 2,
    "cost": 9,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l2-volynov",
    "name": "U.E.S. Volynov 3509-A",
    "shipClass": "Campbell Class Command Cruiser",
    "level": 2,
    "cost": 6,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "blue",
        "effect": {
          "kind": "rerollDice",
          "dice": "both"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "rerollDice",
          "dice": "both"
        }
      }
    }
  },
  {
    "id": "l2-shonin",
    "name": "U.E.S. Shonin 2938-F",
    "shipClass": "Heinlein Class Command Cruiser",
    "level": 2,
    "cost": 9,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l2-demin",
    "name": "U.E.S. Demin 5091-F",
    "shipClass": "Heinlein Class Command Cruiser",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "maxShift": 2,
          "direction": "right"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "diceArrowShift",
          "shift": 1,
          "direction": "right"
        }
      }
    }
  },
  {
    "id": "l2-aksyonov",
    "name": "U.E.S. Aksyonov 7525-G",
    "shipClass": "Clement Class Dreadnaught",
    "level": 2,
    "cost": 7,
    "sector": 8,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "doubleStationReward"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "doubleDeployReward"
        }
      }
    }
  },
  {
    "id": "l2-haise",
    "name": "U.E.S. Haise 3712-D",
    "shipClass": "Harryhausen Class Mining Vessel",
    "level": 2,
    "cost": 7,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-dorrinell",
    "name": "U.E.C. Dorrinell 7621-J",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-maev",
    "name": "U.E.C. Maev 7738-I",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-haylay",
    "name": "U.E.C. Haylay 6526-H",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-kalyah",
    "name": "U.E.C. Kalyah 5205-G",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-bronco",
    "name": "U.E.S. Bronco 1195-E",
    "shipClass": "Vance Class Fuel Runner",
    "level": 2,
    "cost": 12,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    }
  },
  {
    "id": "genesis-rainbow-nebula",
    "name": "Rainbow Nebula",
    "shipClass": "Gala Class Entertainment Starport",
    "level": 2,
    "cost": 8,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-crystal-palace",
    "name": "Crystal Palace",
    "shipClass": "Gala Class Entertainment Starport",
    "level": 2,
    "cost": 8,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-pele",
    "name": "U.E.S. Pele 1686-A",
    "shipClass": "Cyclops Class Mining Laser",
    "level": 2,
    "cost": 8,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "genesis-prometheus",
    "name": "U.E.S. Prometheus 1673-B",
    "shipClass": "Vulcan Class Mining Laser",
    "level": 2,
    "cost": 8,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "income",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-de-leon",
    "name": "U.E.S. De León 8261-C",
    "shipClass": "Convoy Class Mining Freighter",
    "level": 2,
    "cost": 7,
    "sector": 10,
    "station": {},
    "endOfTurnReward": {
      "kind": "income",
      "amount": 2
    },
    "endOfTurnSecondaryReward": {
      "kind": "vp",
      "amount": 1
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 6
      }
    }
  },
  {
    "id": "genesis-tyrell",
    "name": "U.E.S. Tyrell 0001-AI",
    "shipClass": "Dagger Class Medium Escort Drone",
    "level": 2,
    "cost": 9,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-aomame",
    "name": "U.E.S. Aomame 0010-AI",
    "shipClass": "Saber Class Medium Cargo Drone",
    "level": 2,
    "cost": 9,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-talos",
    "name": "U.E.S. Talos 1000-AI",
    "shipClass": "Javelin Class Heavy Escort Drone",
    "level": 2,
    "cost": 9,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-voight",
    "name": "U.E.S. Voight 1100-AI",
    "shipClass": "Pike Class Heavy Cargo Drone",
    "level": 2,
    "cost": 9,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-gort",
    "name": "U.E.S. Gort 1110-AI",
    "shipClass": "Halberd Class Heavy Transport Drone",
    "level": 2,
    "cost": 9,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-deckard",
    "name": "U.E.S. Deckard 0100-AI",
    "shipClass": "Lance Class Medium Transport Drone",
    "level": 2,
    "cost": 9,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-abrams",
    "name": "U.E.S. Abrams 1340-D",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-pournelle",
    "name": "U.E.S. Pournelle 1355-E",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-khonsu",
    "name": "U.E.S. Khonsu 1537-B",
    "shipClass": "Spade Class Shuttlecraft",
    "level": 2,
    "cost": 9,
    "sector": 7,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "both",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "both",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-meili",
    "name": "U.E.S. Meili 8366-A",
    "shipClass": "Spade Class Shuttlecraft",
    "level": 2,
    "cost": 9,
    "sector": 7,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "both",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "both",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-wade",
    "name": "U.E.S. Wade 1408-C",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-bowman",
    "name": "U.E.S. Bowman 1466-F",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-foster",
    "name": "U.E.S. Foster 1471-G",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-bova",
    "name": "U.E.S. Bova 1500-D",
    "shipClass": "Squire Class Supply Carrier",
    "level": 2,
    "cost": 9,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4,
        "arrow": {
          "direction": "left",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "genesis-guild-of-merchants",
    "name": "Guild of Merchants",
    "shipClass": "Midas Class Trade Embassy",
    "level": 2,
    "cost": 7,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "chargeAdjacent",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "chargeAdjacent",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-federation-of-commerce",
    "name": "Federation of Commerce",
    "shipClass": "Midas Class Trade Embassy",
    "level": 2,
    "cost": 7,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 3,
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 3,
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-greenhaven",
    "name": "U.E.S. Greenhaven 1257-G",
    "shipClass": "Lono Class Greenhouse",
    "level": 2,
    "cost": 8,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "text",
        "effect": {
          "kind": "rerollReward"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "rerollReward"
        }
      }
    }
  },
  {
    "id": "genesis-lugger",
    "name": "U.E.S. Lugger 6655-F",
    "shipClass": "Trawler Class Scrap Collector",
    "level": 2,
    "cost": 8,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      },
      "secondaryReward": {
        "kind": "text",
        "effect": {
          "kind": "rerollReward"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "rerollReward"
        }
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-nikola",
    "name": "U.E.S. Nikola 3656-A",
    "shipClass": "Volt Class Power Supply Vessel",
    "level": 2,
    "cost": 7,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAll"
        }
      }
    }
  },
  {
    "id": "genesis-flying-dutchman",
    "name": "The Flying Dutchman",
    "shipClass": "Corsair Class Privateer",
    "level": 2,
    "cost": 8,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "neighborStationReward"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "rerollReward"
        }
      }
    }
  },
  {
    "id": "genesis-haumea",
    "name": "U.E.S. Haumea 1794-G",
    "shipClass": "Solarium Class Arboretum",
    "level": 2,
    "cost": 8,
    "sector": 12,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "buyColonyHalfCost"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "buyColonyHalfCost"
        }
      }
    }
  },
  {
    "id": "genesis-watts",
    "name": "U.E.S. Watts 3802-B",
    "shipClass": "Volt Class Power Supply Vessel",
    "level": 2,
    "cost": 7,
    "sector": 11,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "chargeAllReward"
      }
    },
    "station": {},
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "placeChargeUpToN",
          "max": 3
        }
      }
    }
  },
  {
    "id": "genesis-ulric",
    "name": "U.E.S. Ulric 5422-C",
    "shipClass": "Lodestone Class Freight Tug",
    "level": 2,
    "cost": 7,
    "sector": 1,
    "variableSector": true,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "moveDeployedCard",
        "adjacentOnly": true
      }
    },
    "station": {},
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 5
          }
        }
      }
    }
  },
  {
    "id": "genesis-maddock",
    "name": "U.E.S. Maddock 5866-C",
    "shipClass": "Lodestar Class Freight Tug",
    "level": 2,
    "cost": 7,
    "sector": 1,
    "variableSector": true,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "exchangeAdjacentCard"
      }
    },
    "station": {},
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 3
          }
        }
      }
    }
  },
  {
    "id": "genesis-cortes",
    "name": "U.E.S. Cortés 6612-A",
    "shipClass": "Conquest Class Expedition Carrier",
    "level": 2,
    "cost": 9,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 17
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 11
          }
        }
      }
    }
  },
  {
    "id": "genesis-arroway",
    "name": "U.E.S. Arroway 3348-A",
    "shipClass": "Panoptes Class Deep Space Scanner",
    "level": 2,
    "cost": 8,
    "sector": 8,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 18
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 15
          }
        }
      }
    }
  },
  {
    "id": "shypluto-gort",
    "name": "U.E.S. Gort 8084-F",
    "shipClass": "Gunn Class Cargo Carrier",
    "level": 2,
    "cost": 9,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "shypluto-bennell",
    "name": "U.E.S. Bennell 4239-D",
    "shipClass": "Ripley Class Medium Command Cruiser",
    "level": 2,
    "cost": 7,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll",
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "shypluto-thade",
    "name": "U.E.S. Thade 2261-B",
    "shipClass": "Ripley Class Medium Command Cruiser",
    "level": 2,
    "cost": 7,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll",
          "reward": {
            "kind": "credits",
            "amount": 3
          }
        }
      }
    }
  },
  {
    "id": "shypluto-mandemis",
    "name": "U.E.S. Mandemis 1437-A",
    "shipClass": "Ripley Class Medium Command Cruiser",
    "level": 2,
    "cost": 7,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "text",
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll",
          "reward": {
            "kind": "vp",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "shypluto-morbius",
    "name": "U.E.O. Morbius 1368-B",
    "shipClass": "Galileo Class Research Station",
    "level": 2,
    "cost": 8,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll"
        }
      }
    }
  },
  {
    "id": "shypluto-brodo",
    "name": "U.E.O. Brodo 2212-C",
    "shipClass": "Galileo Class Research Station",
    "level": 2,
    "cost": 7,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll",
          "reward": {
            "kind": "vp",
            "amount": 2
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "bonusRoll",
          "reward": {
            "kind": "vp",
            "amount": 1
          }
        }
      }
    }
  }
];

export const SHIPYARD_LEVEL_3 = [
  {
    "id": "l3-armstrong",
    "name": "U.E.S. Armstrong 6927-D",
    "shipClass": "Lucas Class Gun Carriage",
    "level": 3,
    "cost": 14,
    "sector": 12,
    "station": {
      "ability": {
        "squares": 5,
        "linked": true,
        "pips": [
          null,
          null,
          null,
          2,
          3
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "youWin"
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 10
      }
    }
  },
  {
    "id": "l3-nikolayev",
    "name": "P.S.S. Nikolayev 5815-B",
    "shipClass": "Modified Pohl Class Tug",
    "level": 3,
    "cost": 13,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Claim one level 3 card and one level 1 card.",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 3,
              "count": 1
            },
            {
              "level": 1,
              "count": 1
            }
          ]
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 3,
              "count": 1
            }
          ]
        }
      }
    }
  },
  {
    "id": "l3-scott",
    "name": "U.E.S. Scott 4406-C",
    "shipClass": "Roddenbury Class Hypernet Gate",
    "level": 3,
    "cost": 13,
    "sector": 10,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "buyCardSectorRange",
          "minSector": 7,
          "maxSector": 12
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "buyCardSectorRange",
          "minSector": 7,
          "maxSector": 12
        }
      }
    }
  },
  {
    "id": "l3-cernan",
    "name": "U.E.S. Cernan 9131-H",
    "shipClass": "Sturgeon Class Defender Tug",
    "level": 3,
    "cost": 13,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          3
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 6
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 1,
          "sectorB": 12
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l3-carpenter",
    "name": "U.E.S. Carpenter 2967-E",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 14,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 18
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 10
      }
    }
  },
  {
    "id": "l3-bykovsky",
    "name": "P.S.S. Bykovsky 4498-A",
    "shipClass": "Modified Pohl Class Tug",
    "level": 3,
    "cost": 13,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Claim one level 2 card and one level 1 card.",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 2,
              "count": 1
            },
            {
              "level": 1,
              "count": 1
            }
          ]
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 2,
              "count": 1
            }
          ]
        }
      }
    }
  },
  {
    "id": "l3-white",
    "name": "U.E.S. White 4448-C",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-stafford",
    "name": "U.E.S. Stafford 4286-G",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 13,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 14
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 8
      }
    }
  },
  {
    "id": "l3-anders",
    "name": "U.E.S. Anders 4253-F",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 8
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    }
  },
  {
    "id": "l3-beregovoy",
    "name": "U.E.S. Beregovoy 8603-A",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-conrad",
    "name": "U.E.S. Conrad 5602-E",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-titov",
    "name": "U.E.S. Titov 9072-F",
    "shipClass": "Burroughs Class Command Ship",
    "level": 3,
    "cost": 12,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "blue",
        "effect": {
          "kind": "setDice",
          "dice": "one"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "setDice",
          "dice": "one"
        }
      }
    }
  },
  {
    "id": "l3-cooper",
    "name": "U.E.S. Cooper 6412-D",
    "shipClass": "Clarke Class Mining Vessel",
    "level": 3,
    "cost": 13,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 3
      },
      "secondaryReward": {
        "kind": "credits",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-yegorov",
    "name": "U.E.S. Yegorov 1205-H",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-cunningham",
    "name": "U.E.S. Cunningham 9172-H",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-gordon",
    "name": "U.E.S. Gordon 7981-G",
    "shipClass": "Gernsback Class Destroyer",
    "level": 3,
    "cost": 13,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "allOpponentsLoseVP",
          "amount": 4,
          "extraBuys": 2
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "allOpponentsLoseVP",
          "amount": 3,
          "extraBuys": 1
        }
      }
    }
  },
  {
    "id": "l3-young",
    "name": "U.E.S. Young 6740-G",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-leonov",
    "name": "U.E.S. Leonov 4621-E",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-gagarin",
    "name": "U.E.S. Gagarin 4879-F",
    "shipClass": "Burroughs Class Command Ship",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 1
        },
        "timing": "blue",
        "effect": {
          "kind": "setDice",
          "dice": "one"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "setDice",
          "dice": "one"
        }
      }
    }
  },
  {
    "id": "l3-komarov",
    "name": "U.E.S. Komarov 9388-G",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-lovell",
    "name": "U.E.S. Lovell 1948-A",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-schirra",
    "name": "U.E.S. Schirra 9069-D",
    "shipClass": "Sturgeon Class Defender Tug",
    "level": 3,
    "cost": 14,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          3
        ],
        "bonusReward": {
          "kind": "credits",
          "amount": 2
        },
        "timing": "blue",
        "effect": {
          "kind": "swapSectors",
          "sectorA": 4,
          "sectorB": 10
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "l3-walker",
    "name": "U.E.S. Walker 3930-D",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-popovich",
    "name": "P.S.S. Popovich 8867-G",
    "shipClass": "Modified Pohl Class Tug",
    "level": 3,
    "cost": 13,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Claim two level 2 cards.",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 2,
              "count": 2
            }
          ]
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 3,
              "count": 1
            }
          ]
        }
      }
    }
  },
  {
    "id": "l3-tereshkova",
    "name": "P.S.S. Tereshkova 5875-A",
    "shipClass": "Modified Pohl Class Tug",
    "level": 3,
    "cost": 13,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "text",
        "text": "Claim two level 1 cards.",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 1,
              "count": 2
            }
          ]
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "claimCard",
          "claims": [
            {
              "level": 2,
              "count": 1
            }
          ]
        }
      }
    }
  },
  {
    "id": "l3-feoktistov",
    "name": "U.E.S. Feoktistov 1804-D",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-eisele",
    "name": "U.E.S. Eisele 7639-F",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 6
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l3-aldrin",
    "name": "U.E.S. Aldrin 4775-F",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 7,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 9
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "l3-belyayev",
    "name": "U.E.S. Belyayev 1657-D",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "l3-glenn",
    "name": "U.E.S. Glenn 1817-C",
    "shipClass": "Russel Class Tanker",
    "level": 3,
    "cost": 13,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          3
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": true,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    }
  },
  {
    "id": "l3-collins",
    "name": "U.E.S. Collins 2064-F",
    "shipClass": "Moore Class Fast Tanker",
    "level": 3,
    "cost": 14,
    "sector": 8,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere",
          "thenMoveCharge": true
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "placeChargeAnywhere"
        }
      }
    }
  },
  {
    "id": "l3-mcdivitt",
    "name": "U.E.S. McDivitt 2121-A",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-shatalov",
    "name": "U.E.S. Shatalov 3516-B",
    "shipClass": "Frazetta Class Carrier",
    "level": 3,
    "cost": 14,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 9
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    }
  },
  {
    "id": "l3-borman",
    "name": "U.E.S. Borman 3060-D",
    "shipClass": "Bowie Class Cargo Vessel",
    "level": 3,
    "cost": 12,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 4
      }
    }
  },
  {
    "id": "l3-grissom",
    "name": "U.E.S. Grissom 8139-H",
    "shipClass": "Tucker Class Cargo Train",
    "level": 3,
    "cost": 13,
    "sector": 3,
    "station": {
      "ability": {
        "squares": 3,
        "linked": false,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "blue",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 3
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 2,
        "linked": false,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "repeatable": true,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 3
          }
        }
      }
    }
  },
  {
    "id": "l3-shepard",
    "name": "U.E.S. Shepard 3592-G",
    "shipClass": "Gunn Class Gargo Carrier",
    "level": 3,
    "cost": 13,
    "sector": 2,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null,
          2,
          3
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "credits",
            "amount": 20
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "biodome-winson",
    "name": "U.E.C. Winson 9539-L",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "biodome-aevangel",
    "name": "U.E.C. Aevangel 8874-K",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "biodome-zhora",
    "name": "U.E.C. Zhora 4383-F",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "biodome-eldon",
    "name": "U.E.C. Eldon 3712-E",
    "shipClass": "Nomad Class Hypernet Craft",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 2
      }
    }
  },
  {
    "id": "genesis-asclepius",
    "name": "U.E.S. Asclepius 1282-A",
    "shipClass": "Mercy Class Medic Ship",
    "level": 3,
    "cost": 9,
    "sector": 10,
    "station": {
      "ability": {
        "squares": 2,
        "linked": false,
        "pips": [
          null,
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "bonusRoll",
          "count": 2
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "bonusRoll",
          "count": 2
        }
      }
    }
  },
  {
    "id": "genesis-mandela",
    "name": "U.E.S. Mandela 1071-C",
    "shipClass": "Dragonfly Class Recon Craft",
    "level": 3,
    "cost": 15,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 2,
          "zone": "deployed",
          "min": 1,
          "max": 6
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 1,
          "zone": "station",
          "min": 1,
          "max": 6
        }
      }
    }
  },
  {
    "id": "genesis-auel",
    "name": "U.E.S. Auel 1102-B",
    "shipClass": "Dragonfly Class Recon Craft",
    "level": 3,
    "cost": 13,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "pickSectors",
          "count": 3,
          "zone": "station",
          "min": 1,
          "max": 12
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": null,
        "arrow": {
          "direction": "both",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-mobius",
    "name": "U.E.S. Möbius 9437-E",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 19,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "genesis-phoenix",
    "name": "U.E.S. Phoenix 1226-E",
    "shipClass": "Raptor Class Warbird",
    "level": 3,
    "cost": 20,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    }
  },
  {
    "id": "genesis-artemis",
    "name": "U.E.S. Artemis 1218-C",
    "shipClass": "Raptor Class Warbird",
    "level": 3,
    "cost": 20,
    "sector": 6,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "genesis-edric",
    "name": "U.E.S. Edric 9738-D",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 20,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 8
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    }
  },
  {
    "id": "genesis-murry",
    "name": "U.E.S. Murry 1933-B",
    "shipClass": "Rorick Class Exploratory Vessel",
    "level": 3,
    "cost": 20,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 9
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 6
      }
    }
  },
  {
    "id": "genesis-nemo",
    "name": "U.E.S. Nemo 1965-A",
    "shipClass": "Rorick Class Exploratory Vessel",
    "level": 3,
    "cost": 20,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 11
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 7
      }
    }
  },
  {
    "id": "genesis-ballentine",
    "name": "U.E.S. Ballentine 5736-B",
    "shipClass": "Forage Class Survey Craft Carrier",
    "level": 3,
    "cost": 12,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-flynx",
    "name": "U.E.S. Flynx 5461-C",
    "shipClass": "Forage Class Survey Craft Carrier",
    "level": 3,
    "cost": 17,
    "sector": 1,
    "variableSector": true,
    "station": {
      "reward": {
        "kind": "credits",
        "amount": 3,
        "arrow": {
          "direction": "right",
          "shift": 1
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "credits",
        "amount": 2,
        "arrow": {
          "direction": "left",
          "shift": 1
        }
      }
    }
  },
  {
    "id": "genesis-united-treasury",
    "name": "United Treasury",
    "shipClass": "Midas Class Trade Embassy",
    "level": 3,
    "cost": 13,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 1,
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 1,
          "reward": {
            "kind": "income",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-cosmo",
    "name": "U.E.S. Cosmo 1728-H",
    "shipClass": "Hermes Class Transmission Station",
    "level": 3,
    "cost": 12,
    "sector": 4,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "chargeAdjacent",
          "reward": {
            "kind": "vp",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "chargeAdjacent",
          "reward": {
            "kind": "vp",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-valentine",
    "name": "Valentine",
    "shipClass": "Leisure Class Resort Ship",
    "level": 3,
    "cost": 12,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 1,
          "reward": {
            "kind": "credits",
            "amount": 1
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "denseSector",
          "threshold": 1,
          "reward": {
            "kind": "credits",
            "amount": 1
          }
        }
      }
    }
  },
  {
    "id": "genesis-mercury",
    "name": "U.E.S. Mercury 1715-H",
    "shipClass": "Hermes Class Transmission Station",
    "level": 3,
    "cost": 12,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "charge",
          "reward": {
            "kind": "vp",
            "amount": 2
          }
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "charge",
          "reward": {
            "kind": "vp",
            "amount": 2
          }
        }
      }
    }
  },
  {
    "id": "genesis-dalton",
    "name": "U.E.S. Dalton 3733-I",
    "shipClass": "Regin Class Fabrication Ship",
    "level": 3,
    "cost": 12,
    "sector": 9,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "peekAndClaim",
          "level": 2,
          "count": 2
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "peekAndClaim",
          "level": 2,
          "count": 2
        }
      }
    }
  },
  {
    "id": "genesis-mary",
    "name": "U.E.S. Mary 1337-B",
    "shipClass": "Mercy Class Medic Ship",
    "level": 3,
    "cost": 12,
    "sector": 7,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "bonusRoll",
        "count": 4
      }
    },
    "station": {},
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "bonusRoll",
          "count": 2
        }
      }
    }
  },
  {
    "id": "genesis-triumph",
    "name": "U.E.S. Triumph 3231-H",
    "shipClass": "Moxie Class Tractor Tug",
    "level": 3,
    "cost": 13,
    "sector": 11,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "moveDeployedCard",
        "destinations": [
          7,
          8,
          9
        ]
      }
    },
    "station": {},
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "genesis-iris",
    "name": "U.E.S. Iris 1156-D",
    "shipClass": "Hermes Class Transmission Station",
    "level": 3,
    "cost": 14,
    "sector": 1,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "immediateRewardCard",
          "reward": {
            "kind": "vp",
            "amount": 1
          },
          "flatAmount": 2
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "scaledReward",
          "per": "immediateRewardCard",
          "reward": {
            "kind": "vp",
            "amount": 1
          },
          "flatAmount": 2
        }
      }
    }
  },
  {
    "id": "genesis-zenith",
    "name": "U.E.S. Zenith 6487-A",
    "shipClass": "Overseer Class Dispatch Station",
    "level": 3,
    "cost": 14,
    "sector": 5,
    "station": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 15
          }
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 4,
        "linked": true,
        "pips": [
          null,
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "grantResource",
          "reward": {
            "kind": "vp",
            "amount": 10
          }
        }
      }
    }
  },
  {
    "id": "genesis-pharos",
    "name": "U.E.S. Pharos 6348-A",
    "shipClass": "Hina Class Dispatch Station",
    "level": 3,
    "cost": 13,
    "sector": 1,
    "immediateReward": {
      "kind": "text",
      "effect": {
        "kind": "emptySectorRange",
        "min": 7,
        "max": 12
      }
    },
    "station": {},
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "emptySectorChoice"
        }
      }
    }
  },
  {
    "id": "terraproxima-scarleth",
    "name": "U.E.S. Scarleth 6288-D",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 17,
    "sector": 8,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 7
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    }
  },
  {
    "id": "terraproxima-lupin",
    "name": "U.E.S. Lupin 8048-E",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 17,
    "sector": 10,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 8
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 5
      }
    }
  },
  {
    "id": "terraproxima-horrison",
    "name": "U.E.S. Horrison 1132-A",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 19,
    "sector": 2,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "terraproxima-viliana",
    "name": "U.E.S. Viliana 4853-C",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 19,
    "sector": 5,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 4
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3
      }
    }
  },
  {
    "id": "terraproxima-antoniye",
    "name": "U.E.S. Antoniye 2237-B",
    "shipClass": "Hatcher Class Deep Space Carrier",
    "level": 3,
    "cost": 14,
    "sector": 3,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 2
      },
      "secondaryReward": {
        "kind": "income",
        "amount": 1
      }
    },
    "deployed": {
      "reward": {
        "kind": "income",
        "amount": 1
      },
      "secondaryReward": {
        "kind": "vp",
        "amount": 1
      }
    }
  },
  {
    "id": "terraproxima-mezieres",
    "name": "U.E.S. Mézières 9275-E",
    "shipClass": "Wollheim Command Relay Craft",
    "level": 3,
    "cost": 14,
    "sector": 11,
    "station": {
      "reward": {
        "kind": "vp",
        "amount": 5,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "vp",
        "amount": 3,
        "arrow": {
          "direction": "right",
          "shift": 1,
          "crossZone": true
        }
      }
    }
  },
  {
    "id": "terraproxima-nemesis",
    "name": "U.E.S. Nemesis 9637-X",
    "shipClass": "Heinlein Class Command Cruiser",
    "level": 3,
    "cost": 18,
    "sector": 12,
    "station": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "sectorRangeReward",
          "zone": "station",
          "min": 1,
          "max": 11
        }
      }
    },
    "deployed": {
      "reward": {
        "kind": "text",
        "effect": {
          "kind": "sectorRangeReward",
          "zone": "deployed",
          "min": 1,
          "max": 11
        }
      }
    }
  },
  {
    "id": "terraproxima-stirling",
    "name": "U.E.S. Stirling 5741-F",
    "shipClass": "Eagle Class Scout",
    "level": 3,
    "cost": 12,
    "sector": 9,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "buyCardDiscount",
          "amount": 3
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "buyCardDiscount",
          "amount": 3
        }
      }
    }
  },
  {
    "id": "terraproxima-tesla",
    "name": "U.E.S. Tesla 9900-A",
    "shipClass": "Odysseus Class Hypernet Craft",
    "level": 3,
    "cost": 13,
    "sector": 7,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "exchangeCard"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "green",
        "effect": {
          "kind": "exchangeCard"
        }
      }
    }
  },
  {
    "id": "terraproxima-genesis-ship",
    "name": "U.E.C. Genesis 0036-A",
    "shipClass": "Gaïa Class Terrarium Ship",
    "level": 3,
    "cost": 12,
    "sector": 6,
    "station": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          3
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "buyColonyDiscount",
          "amount": 9
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 3,
        "linked": true,
        "pips": [
          null,
          null,
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "buyColonyDiscount",
          "amount": 9
        }
      }
    }
  },
  {
    "id": "terraproxima-zarinah",
    "name": "U.E.S. Zarinah 9239-F",
    "shipClass": "Lomax Class Cargo Vessel",
    "level": 3,
    "cost": 13,
    "sector": 4,
    "station": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "blue",
        "effect": {
          "kind": "doubleStationReward"
        }
      }
    },
    "deployed": {
      "ability": {
        "squares": 1,
        "linked": false,
        "pips": [
          null
        ],
        "bonusReward": null,
        "timing": "red",
        "effect": {
          "kind": "doubleDeployReward"
        }
      }
    }
  }
];

export const SHIPYARD_CARDS = [...SHIPYARD_LEVEL_1, ...SHIPYARD_LEVEL_2, ...SHIPYARD_LEVEL_3];

export const ALL_CARDS = [...STARTER_CARDS, ...COLONY_CARDS, ...EXPANSION_COLONIES, ...SHIPYARD_CARDS];
